module.exports = __webpack_public_path__ + "img/page3.bf8aaf31.jpeg";